const COOKIEBOT_GTM_CONSENT_BRIDGE_SCRIPT_LINES = [
  "window.addEventListener('CookiebotOnAccept', function() {",
  "  if (typeof gtag === 'function') {",
  "    gtag('consent', 'update', {",
  "      'analytics_storage': Cookiebot.consent.statistics ? 'granted' : 'denied',",
  "      'ad_storage': Cookiebot.consent.marketing ? 'granted' : 'denied',",
  "      'ad_user_data': Cookiebot.consent.marketing ? 'granted' : 'denied',",
  "      'ad_personalization': Cookiebot.consent.marketing ? 'granted' : 'denied',",
  "      'functionality_storage': Cookiebot.consent.preferences ? 'granted' : 'denied',",
  "      'personalization_storage': Cookiebot.consent.preferences ? 'granted' : 'denied'",
  '    });',
  '  }',
  '}, false);',
  "window.addEventListener('CookiebotOnDecline', function() {",
  "  if (typeof gtag === 'function') {",
  "    gtag('consent', 'update', {",
  "      'analytics_storage': 'denied',",
  "      'ad_storage': 'denied',",
  "      'ad_user_data': 'denied',",
  "      'ad_personalization': 'denied',",
  "      'functionality_storage': 'denied',",
  "      'personalization_storage': 'denied'",
  '    });',
  '  }',
  '}, false);',
];

/** Inline script: sync Cookiebot accept/decline to gtag Consent Mode (for GTM). */
export const buildCookiebotGtmConsentBridgeScript = (): string =>
  COOKIEBOT_GTM_CONSENT_BRIDGE_SCRIPT_LINES.join('\n');
